const DEFAULT_SERVER_PRO = "https://www.wiki-menu.app"; 
const DEFAULT_SERVER_DEV = "https://www.wiki-menu.app"; //"http://192.168.1.133:1337"; 

function isTrueMeta(value){
  return typeof value === "string" && value.trim().toLowerCase() === "true";
}

 function getServer() {
  let appEnv = getMeta("env");
  if(!appEnv){
    appEnv=process.env.NODE_ENV;
  }

  const metaServer = getMeta("server");
  const safeServerEnabledRaw = getMeta("safe-server-enabled");
  let server = metaServer;
  const safeServerUrl = getMeta("safe-server-url");
  const safeServerEnabled = isTrueMeta(safeServerEnabledRaw);
  let serverSource = "server";

  if(safeServerEnabled && safeServerUrl){
    server = safeServerUrl;
    serverSource = "safe-server-url";
    console.log('meta safe server enabled, loading safe server:',server);
  }

  if(!server){
    server =  process.env.NODE_ENV==='development'? DEFAULT_SERVER_DEV: DEFAULT_SERVER_PRO;
    serverSource = "default";
    console.log('meta server undefinido, loading default:',server); 
  }

  let appLogs = getMeta("logs");
  if(!appLogs){
    appLogs=process.env.NODE_ENV==='development';
  }

  const serverEnv={
    server:server, 
    logs:appLogs,
    env:appEnv
  }

  console.log('serverEnv', {
    ...serverEnv,
    serverSource,
    metaServer,
    safeServerUrl,
    safeServerEnabledRaw,
    safeServerEnabled
  }); 
  return serverEnv; 
 }


 function getMeta(name){
  let result = document.querySelector(`meta[name='${name}']`)?.content
  return result;
}

 export {
    getServer
 }
